module.exports = __webpack_public_path__ + "static/media/ice1.cf0ef4ea.png";